<template>
  <div class="main">
    <Preloader v-if="$store.getters.isLoading" />
    <Notifications />
    <router-view></router-view>
  </div>
</template>

<script>
import Notifications from '../components/Notifications.vue'
import Preloader from '../components/Preloader.vue'
import bridge from '@open-condo/bridge'
import config from 'MainDir/config.js'

export default {
  name: 'App',
  components: { Notifications, Preloader },
  data() {
    return {}
  },
  mounted() {
    if (config.isProduction) {
      const observer = new ResizeObserver(entries => {
        if (entries && entries.length) {
          try {
            bridge.send('CondoWebAppResizeWindow', {
              height: entries[0].target.clientHeight + 100,
            })
          } catch (e) {
            //
          }
        }
      })

      observer.observe(document.body)
    }
  },
  computed: {},
}
</script>

<style lang="scss" scoped>
body {
  margin: 0px;
  padding: 0px;
}

* {
  font-family: 'Open Sans', sans-serif;
  font-style: normal;
  font-size: $font-size-lg;
  font-weight: $font-weight-md;
}

.main {
  position: relative;
  margin: $space-xxl;
}
</style>
